import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Head from 'next/head';
import get from 'lodash.get';

import { formatVertical } from 'lib/ampUtils';
import { shouldRenderRegularBlog } from 'lib/liveBlog';
import { getFeatureConfigForBrand } from 'lib/getFeatureStatus';
import { AMPHTML_VIDEO_LINK } from 'lib/brandFeatures.json';

export const buildAMPHTMLLink = ({
  content, domain, isLiveBlog, vertical,
}) => {
  const id = get(content, 'id', null);

  // Return null if content ID does not start with n, t, r, m or w
  // (like - ncna##, tdna##, rcna##, mmvo##, wbna##)

  if (!domain || !vertical || !id || !/^[ntrmw]/.test(id)) {
    return null;
  }

  // handles video page routing for msnbc, news, and today
  let amp = 'amp';
  if (content.type === 'video') {
    const showAmpVideoLink = getFeatureConfigForBrand(AMPHTML_VIDEO_LINK, vertical);
    if (showAmpVideoLink) {
      amp = 'amp-video';
    } else {
      return null;
    }
  }

  const nativeAd = get(content, 'nativeAd', false);
  const presentationStyle = get(content, ['presentation', 'style'], null);

  if (nativeAd || presentationStyle === 'shell') {
    return null;
  }

  let sub = '';
  if (isLiveBlog) {
    const subType = get(content, 'subType', null);
    sub = shouldRenderRegularBlog(subType) ? 'blog/' : 'live-blog/';
  }

  return `https://www.${domain}/${formatVertical(vertical)}/${amp}/${sub}${id}`;
};

const AMPHTMLLink = (props) => {
  const {
    content, domain, isLiveBlog, vertical,
  } = props;

  const link = buildAMPHTMLLink({
    content, domain, isLiveBlog, vertical,
  });

  if (link) {
    return (
      <Head>
        <link rel="amphtml" href={link} />
      </Head>
    );
  }
  return null;
};

AMPHTMLLink.propTypes = {
  content: PropTypes.shape({ }).isRequired,
  domain: PropTypes.string.isRequired,
  isLiveBlog: PropTypes.bool,
  vertical: PropTypes.string.isRequired,
};

AMPHTMLLink.defaultProps = {
  isLiveBlog: false,
};

const mapStateToProps = ({ router }) => ({
  domain: router.domain,
});

export default connect(mapStateToProps)(AMPHTMLLink);
